import { LearnerLearningRecord } from "src/app/_models/LearnerLearningRecord";

export interface LearningRecordTabState {
    course: number;
    panelState: LearnerLearningRecord[];
    loading: boolean;
    error: boolean;
};

export const initialLearningRecordTabState: LearningRecordTabState = {
    course: 0,
    panelState: [],
    loading: false,
    error: false
}